import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class app_custom_ds_get_load_container_by_pick_taskIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { id: number }): 
  Promise<{ result: { Id?: number, OrderId?: number, ShipmentId?: number, WarehouseId?: number, Shipment?: { Id?: number, LoadContainer?: { Id?: number, MovuRobotics_ShipmentDownload_Status?: string } } } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.id)) {
      $missingRequiredInParams.push('\'id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      id: number    }) {
        if(isNil($inParams.id)) {
          return true; 
        }
      return false;
    }
}
